<template>
    <cic-popup
        id="edit_link_definition_style"
        :title="item.linkId ? $t('Edit LINK Style') : $t('Edit Default Style')"
        :saveable="editing"
        @blur="$emit('blur')"
        @input="$emit('input')"
    >
        <ul class="item-form">
            <li class="form-label">{{ $t('Logo') }}</li>
            <li>
                <ElUpload
                    id="fileUploader"
                    ref="uploader"
                    :auto-upload="false"
                    :accept="extensions.map((x) => `.${x}`).join(',')"
                    :limit="1"
                    :on-change="handleChange"
                    :on-exceed="handleExceed"
                    :on-remove="handleRemove"
                    :file-list="fileList"
                >
                    <cic-button id="fileUploadButton" class="upload-file-button">
                        {{ $t('Upload File') }}
                    </cic-button>
                </ElUpload>
                <div v-if="item.logo != '' && item.logo != null">
                    <img id="logoImage" max-width="500" height="100" :src="'data:image/png;base64, ' + item.logo" />
                </div>
            </li>

            <li class="form-label">{{ $t('Header Title') }}</li>
            <li>
                <cic-textarea
                    id="headerTitle"
                    :enabled="editing"
                    :value="item.headerTitle ? item.headerTitle : ''"
                    :maxlength="4000"
                    @input="(val) => updateFieldValue('headerTitle', val)"
                />
            </li>

            <li class="form-label">{{ $t('Header Background Colour') }}</li>
            <li>
                <ElColorPicker
                    id="headerBackgroundColourColourPicker"
                    :model-value="item.headerBackgroundColour ? item.headerBackgroundColour : ''"
                    :disabled="!editing"
                    @change="(val) => updateFieldValue('headerBackgroundColour', val ? val : '')"
                />
            </li>

            <li class="form-label">{{ $t('Header Text Colour') }}</li>
            <li>
                <ElColorPicker
                    id="headerTextColourColourPicker"
                    :model-value="item.headerTextColour ? item.headerTextColour : ''"
                    :disabled="!editing"
                    @change="(val) => updateFieldValue('headerTextColour', val ? val : '')"
                />
            </li>

            <li class="form-label">{{ $t('Button Colour') }}</li>
            <li>
                <ElColorPicker
                    id="buttonColourColourPicker"
                    :model-value="item.buttonColour ? item.buttonColour : ''"
                    :disabled="!editing"
                    @change="(val) => updateFieldValue('buttonColour', val ? val : '')"
                />
            </li>

            <li class="form-label">{{ $t('Button Text Colour') }}</li>
            <li>
                <ElColorPicker
                    id="buttonTextColourColourPicker"
                    :model-value="item.buttonTextColour ? item.buttonTextColour : ''"
                    :disabled="!editing"
                    @change="(val) => updateFieldValue('buttonTextColour', val ? val : '')"
                />
            </li>

            <li class="form-label">{{ $t('Font Style') }}</li>
            <li>
                <cic-select
                    id="fontStyleSelect"
                    :enabled="editing"
                    :value="item.fontFamily"
                    :options="[
                        { value: 'Arial', label: $t('Arial') },
                        { value: 'Brush Script MT', label: $t('Brush Script MT') },
                        { value: 'Courier New', label: $t('Courier New') },
                        { value: 'Garamond', label: $t('Garamond') },
                        { value: 'Georgia', label: $t('GeorgiaFont') },
                        { value: 'Tahoma', label: $t('Tahoma') },
                        { value: 'Times New Roman', label: $t('Times New Roman') },
                        { value: 'Trebuchet MS', label: $t('Trebuchet MS') },
                        { value: 'Verdana', label: $t('Verdana') },
                    ]"
                    @input="(val) => updateFieldValue('fontFamily', val)"
                />
            </li>
        </ul>
    </cic-popup>
</template>

<script>
    import { ElColorPicker, ElUpload } from 'element-plus';
    import CicButton from '@/components/CicButton';
    import CicPopup from '@/components/CicPopup';
    import CicSelect from '@/components/inputs/CicSelect';
    import CicTextarea from '@/components/inputs/CicTextarea';

    export default {
        name: 'EditLinkDefinitionStyle',
        components: {
            CicButton,
            CicPopup,
            CicSelect,
            CicTextarea,
            ElColorPicker,
            ElUpload,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        emits: ['blur', 'change', 'input'],
        data() {
            return {
                editing: true,
                fileList: this.item.logo
                    ? [
                          {
                              name: 'Uploaded Image',
                          },
                      ]
                    : [],
                extensions: ['jpg', 'gif', 'bmp', 'jpeg', 'svg', 'png'],
            };
        },
        created() {
            this.editing = !this.item.linkId || this.$store.hasRight('EDIT_LINK');
        },
        methods: {
            updateFieldValue(field, value) {
                this.$emit('change', field, value);
            },
            handleExceed(files) {
                this.$refs.uploader.clearFiles();
                const file = files[0];
                this.$refs.uploader.handleStart(file);
            },
            handleChange(file, fileList) {
                if (
                    !file.name.includes('.') ||
                    !this.extensions.includes(file.name.substring(file.name.lastIndexOf('.') + 1))
                ) {
                    fileList.splice(fileList.indexOf(file), 1);
                    alert(this.$t('Invalid file type!'));
                } else {
                    let reader = new FileReader();
                    reader.onload = (evt) => {
                        this.updateFieldValue('logo', evt.target.result.replace('data:', '').replace(/^.+,/, ''));
                    };
                    reader.readAsDataURL(file.raw);
                }
            },
            handleRemove() {
                this.updateFieldValue('logo', '');
            },
        },
    };
</script>
